module.exports = __webpack_public_path__ + "img/setting-icon-active.58b06316.png";